<template>
  <div>
    <div class="form-container ou-donation-form jlic-donation-form jlicformlg">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Support Us">
            <AmountSelectorList v-if="form.applications[0].department === 'JLIC_Brandeis' || form.applications[0].department === 'JLIC_Binghamton' || form.applications[0].department === 'JLIC_NYU' || form.applications[0].department === 'JLIC_Princeton'"/>
            <AmountSelector v-else/>
            <ErrorLabel field="amount" />
            <FormRow inline>
              <FormCol field="designation" width="half">
                <FormSelect>
                  <option value="General Donation">Any Program</option>
                  <option value="Tishraise" v-if="form.applications[0].department == 'JLIC_BrooklynCollege'">tishraise</option>
                  <option value="Brooklyn Auction" v-if="form.applications[0].department == 'JLIC_BrooklynCollege'">Brooklyn Auction</option>
                  <option value="General Donation">General Donation</option>
                  <option value="Programming Fund">Programming Fund</option>
                  <option value="Challenge Grant" v-if="form.applications[0].department == 'JLIC_Binghamton'">Challenge Grant</option>
                  <option value="Family Shabbaton" v-if="form.applications[0].department == 'JLIC_Binghamton'">Family Shabbaton</option>
                  <option value="Family Shabbaton" v-if="form.applications[0].department == 'JLIC_Binghamton'">Haggadah</option>
                  <option value="Challenge Grant" v-if="form.applications[0].department == 'JLIC_Columbia'">Challenge Grant</option>
                  <option value="Challenge Grant" v-if="form.applications[0].department == 'JLIC_UCLA'">Challenge Grant</option>
                  <option value="Toppings" v-if="form.applications[0].department == 'JLIC_UCLA'">Toppings</option>
                  <option value="Payment For Program" v-if="form.applications[0].department == 'JLIC_Chicago'">Payment For Program</option>
                  <option value="Payment For Program" v-if="form.applications[0].department == 'JLIC_Penn'">Payment For Program</option>
                  <option value="General Donation" v-if="form.applications[0].department == 'JLIC_BrooklynCollege'"> JLIC Alumni Halacha Chat</option>
                </FormSelect>
              </FormCol>
            </FormRow>
            <TransactionFee />
          </FormSection>
          <FormSection title="Donation Frequency">
            <DonationFrequency />
          </FormSection>
          <FormSection title="Your Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
              <Consent privacy="https://www.ou.org/privacy-policy/"/>
            </FormRow>
            <FormRow>
              <FormLabel>
                <input type="checkbox" field="custom.contactMe" :checked="contactMe" @click="contactMe = $event.target.checked" /> Would you like us to contact you regarding
                naming opportunities?
              </FormLabel>
            </FormRow>
            <InHonorOf />
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  setup() {
    const { setValue, form } = usePaymentForm();

    const contactMe = ref();

    watch(contactMe, () => {
      if (contactMe.value) {
        setValue("custom.contactMe", contactMe.value);
      }
    });
    return {
      form,
      contactMe,
      setValue,
    };
  },
});
</script>

<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
::v-deep span.flex > span {
    display: flex;
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container .radio-part {
  @media (min-width: 720px) {
    min-width: 22.6%;
    max-width: 22.6%;
  }
}

::v-deep input#inHonorOf {
    margin-top: -3px;
}

::v-deep input#amount_other {
  margin-left: auto !important;
    font-size: 14px !important;
    padding-bottom: 0px !important;
    max-width: 227px !important;
    width: 100%;
}
</style>
